import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-decrease-button',
  templateUrl: './nav-decrease-button.component.html',
  styleUrls: ['./nav-decrease-button.component.scss'],
})
export class NavDecreaseButtonComponent {}
